import { useEffect } from "react";
import GoogleMapPicker from "./GoogleMapPicker";

const AddressSelectionCard = ({ bookingData, setBookingData }) => {
  useEffect(() => {
    const isValid =
      bookingData.location.coordinates.length === 2 &&
      bookingData.location.address.formatted.trim().length > 0;

    setBookingData((prev) => ({
      ...prev,
      __addressValid: isValid,
    }));
  }, [bookingData.location, setBookingData]);

  const inputFieldClasses =
    "w-full rounded-lg px-3 py-2.5 outline-none ring-1 ring-brandAccentColor focus:ring-primaryColor";

  return (
    <div className="w-full max-w-3xl mx-auto space-y-6">
      {/* MAP */}
      <div className="space-y-2">
        <GoogleMapPicker
          location={bookingData.location}
          onChange={(location) =>
            setBookingData((prev) => ({
              ...prev,
              location,
            }))
          }
        />

        <div className="text-xs text-center text-orange-700 bg-orange-50 border border-orange-200 rounded-lg px-3 py-2 w-fit mx-auto">
          Drag the pin to fine-tune your exact location
        </div>
      </div>

      <div className="space-y-4">
        {/* FULL ADDRESS */}
        <div>
          <label className="text-xs font-medium text-gray-600">
            Full Address
          </label>
          <input
            type="text"
            placeholder="House no, street, area, city"
            value={bookingData.location.address.formatted}
            onChange={(e) =>
              setBookingData((prev) => ({
                ...prev,
                location: {
                  ...prev.location,
                  address: {
                    ...prev.location.address,
                    formatted: e.target.value,
                  },
                },
              }))
            }
            className={`${inputFieldClasses} mt-1 text-sm`}
          />
        </div>

        {/* STREET + LOCALITY */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-medium text-gray-600">
              Street / Flat
            </label>
            <input
              type="text"
              placeholder="Flat / House no, Building name"
              value={bookingData.location.address.street}
              onChange={(e) =>
                setBookingData((prev) => ({
                  ...prev,
                  location: {
                    ...prev.location,
                    address: {
                      ...prev.location.address,
                      street: e.target.value,
                    },
                  },
                }))
              }
              className={`${inputFieldClasses} mt-1 text-sm`}
            />
          </div>

          <div>
            <label className="text-xs font-medium text-gray-600">
              Area / Locality
            </label>
            <input
              type="text"
              placeholder="Area, locality or landmark"
              value={bookingData.location.address.locality}
              onChange={(e) =>
                setBookingData((prev) => ({
                  ...prev,
                  location: {
                    ...prev.location,
                    address: {
                      ...prev.location.address,
                      locality: e.target.value,
                    },
                  },
                }))
              }
              className={`${inputFieldClasses} mt-1 text-sm`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressSelectionCard;
